import React from 'react'
import styled from 'styled-components'
import CircularProgress from '@material-ui/core/CircularProgress'

const CircularLoader = () => <CircularProgress />
export default CircularLoader
